import axios from '@/api/request'

/**
 * 企业端认证（views/enterprise/login）接口定义
 * 已联调真实后端（平台服务 API · 企业·认证）；统一响应 { code, message, data, trace_id }，code=0 成功。
 * 密码类字段均为客户端 sha256 摘要（64 位小写 hex），不传输明文。
 */

// 账密登录 { mobile, password: sha256, captcha_id, captcha_code } → { access_token, refresh_token, user_id, expires_in, refresh_expires_in }
export const adminloginByPassword = (params) => axios('post', '/api/ent/login', params)

// 获取图形验证码（YApi 1469 · 企业·认证）入参 {} → { captcha_id, expires_in, image_base64, provider }
// 公开端点；image_base64 为 PNG base64（不含 data: 前缀）；验证码一次性、expires_in 秒内有效，校验即失效
export const entCaptcha = () => axios('post', '/api/ent/captcha', {})

// 服务器配置（YApi 1477 · 企业·认证）入参 {} → { captcha_enabled, captcha_provider, server_time, server_timestamp, tencent_captcha_appid }
// 公开端点；captcha_provider: image=数字图形 / tencent=腾讯防水墙 / none=未开启
// silent：开关属于可选兜底查询，失败不弹窗，由登录页 fail-close 隐藏验证码
export const entServerConfig = () => axios('post', '/api/ent/server/config', {}, false, true)

// 短信验证码登录 { mobile, code } → 同账密登录
export const adminloginByCode = (params) => axios('post', '/api/ent/login/sms', params)

// 短信登录·发送验证码 { mobile, captcha_id?, captcha_code? } → { expires_in, retry_after }
// 图形验证码开关开启时 captcha_id/captcha_code 必填；短信登录接口本身不再校验图形验证码
export const adminsendSmsCode = (params) => axios('post', '/api/ent/login/sms/code', params)

// 当前登录用户信息（令牌鉴权，入参 {}）→ 个人基本信息 + 部门/角色/权限 node_keys
export const admingetuser = (params) => axios('post', '/api/ent/profile', params)

// 忘记密码·发送验证码 { mobile, captcha_id?, captcha_code? } → { expires_in, retry_after }
// 图形验证码开关开启时 captcha_id/captcha_code 必填；验证码一次性，校验即失效
export const sendResetCode = (params) => axios('post', '/api/ent/password/forgot/code', params)

// 忘记密码·校验验证码 { mobile, code } → { reset_token, expires_in }
export const verifyResetCode = (params) => axios('post', '/api/ent/password/forgot/verify', params)

// 忘记密码·重置密码 { reset_token, new_password: sha256 } → { success }
export const resetPassword = (params) => axios('post', '/api/ent/password/forgot/reset', params)

// 修改密码（YApi 781 · 企业·认证）{ old_password: sha256, new_password: sha256 } → { success }
// 校验旧密码；成功后该用户全部会话失效，需重新登录
export const entPasswordUpdate = (params) => axios('post', '/api/ent/password/update', params)

// 免登录票据兑换（BOSS  impersonate 中转页使用）{ code } → { access_token }
// 中转页 /ent/impersonate 调用：此时尚无 enterprisetoken，无需鉴权；成功后写入 localStorage.enterprisetoken
export const entImpersonate = (params) => axios('post', '/api/ent/impersonate', params)

// 登出（YApi 717 · 企业·认证）→ { success }
// access_token 缺省取 Authorization 头（request 层已注入）；silent：失败不弹窗，由调用方继续本地清理
export const entuserLogout = () => axios('post', '/api/ent/logout', {}, false, true)
